import { UI_LOCALES } from '../countries/types';
import { z } from 'zod';
import { phoneSchema } from '../api';
export const loginSchema = z.object({
    /** Email or phone; the tenant is resolved from the subdomain / X-Tenant-Id header. */
    identifier: z.string().trim().min(3).max(190),
    password: z.string().min(8).max(200),
    /** Required when the account (or its role) enforces TOTP. */
    totp: z.string().regex(/^\d{6}$/).optional(),
});
export const refreshSchema = z.object({ refreshToken: z.string().min(20).max(2048).optional() }).optional();
export const SESSION_KINDS = ['tenant', 'platform', 'owner'];
export const SESSION_KIND_HEADER = 'X-Session-Kind';
export const REFRESH_TRANSPORT_HEADER = 'X-Refresh-Transport';
export const REFRESH_TRANSPORTS = ['body', 'upgrade'];
export const changePasswordSchema = z
    .object({
    currentPassword: z.string().min(8),
    newPassword: z
        .string()
        .min(10, 'Use at least 10 characters')
        .max(200)
        .regex(/[a-z]/, 'Add a lowercase letter')
        .regex(/[A-Z]/, 'Add an uppercase letter')
        .regex(/\d/, 'Add a digit')
        .regex(/[^A-Za-z0-9]/, 'Add a symbol (e.g. ! @ # $ %)'),
    confirmPassword: z.string(),
})
    .refine((v) => v.newPassword === v.confirmPassword, {
    path: ['confirmPassword'],
    message: 'Passwords do not match',
});
export const enroll2faSchema = z.object({ totp: z.string().regex(/^\d{6}$/) });
export const platformLoginSchema = z.object({
    email: z.string().email(),
    password: z.string().min(8).max(200),
    totp: z.string().regex(/^\d{6}$/).optional(),
});
/**
 * Owner-portal sign-in, LIMS-parity (../lims SPEC-V2 §1.4): email + 6-digit
 * TOTP only — no password. Email alone starts enrolment on the very first
 * sign-in; email + code completes it (and is every later sign-in).
 */
export const ownerLoginSchema = z.object({
    email: z.string().email(),
    totp: z.string().regex(/^\d{6}$/).optional(),
    enrolmentCode: z.string().trim().min(10).max(64).optional(),
});
export const portalRequestOtpSchema = z.object({ phone: phoneSchema });
export const portalVerifyOtpSchema = z.object({
    phone: phoneSchema,
    otp: z.string().regex(/^\d{6}$/),
});
export const userPreferencesSchema = z.object({
    locale: z.preprocess((value) => (value === 'ur' ? 'ur-Latn' : value === '' ? null : value), z.enum(UI_LOCALES).nullable().optional()),
});
//# sourceMappingURL=auth.js.map